module.exports = __webpack_public_path__ + "media/images/japan/carousel-arrow-next-050c3b31f5ab9f4965ac3477df337fc5.svg";